var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"cta"},[(!_vm.processing)?_c('span',[_vm._t("default")],2):_c('span',{domProps:{"textContent":_vm._s(_vm.translations.saving)}})])}
var staticRenderFns = []

export { render, staticRenderFns }